import { linksSlice } from './slice';

const Reducer = linksSlice.reducer;

export { Reducer };
export type { LogicLinkParamsState } from './links';
